<template>
  <div :class="classNames">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    hidden: Boolean,
    onScroll: Function,
    onTouchMove: Function,
    onTouchStart: Function,
    onTouchEnd: Function,
    transparent: Boolean
  },
  computed: {
    classNames () {
      return {
        'layout__scroll': true,
        'ui__scrollbar--transparent': this.transparent,
        'ui__scrollbar--hidden': this.hidden
      }
    }
  },
  methods: {
    resetScroll () {
      this.$el.scrollTop = 0
    }
  },
  mounted () {
    if (this.onScroll) this.$el.addEventListener('scroll', this.onScroll)
    if (this.onTouchMove) this.$el.addEventListener('touchmove', this.onTouchMove, { passive: true })
    if (this.onTouchStart) this.$el.addEventListener('touchstart', this.onTouchStart, { passive: true })
    if (this.onTouchEnd) this.$el.addEventListener('touchend', this.onTouchEnd, { passive: true })
  },
  destroyed () {
    this.$el.removeEventListener('scroll', this.onScroll)
    this.$el.removeEventListener('touchmove', this.onTouchMove)
    this.$el.removeEventListener('touchstart', this.onTouchStart)
    this.$el.removeEventListener('touchend', this.onTouchEnd)
  }
}
</script>

<style lang="sass">
@import "../styles/variables.scss"

.layout__scroll
  position: relative
  overflow-y: auto
  overflow-x: hidden
  -webkit-overflow-scrolling: touch
  .device__viewport-class--compact &
    overflow-x: hidden
.ui__scrollbar--hidden
  -webkit-overflow-scrolling: touch
  &::-webkit-scrollbar
    width: 0
.ui__scrollbar--transparent
  &::-webkit-scrollbar
    background: transparent
    width: 16px
  &::-webkit-scrollbar-thumb
    width: 22px
    height: 6px
    border: 4px solid rgba(0, 0, 0, 0)
    background-clip: padding-box
    border-radius: 15px
    background-color: rgba(0, 0, 0, 0.15)
    box-shadow: inset -1px -1px 0px rgba(0, 0, 0, 0.05), inset 1px 1px 0px rgba(0, 0, 0, 0.05)
  &.theme--dark
    &::-webkit-scrollbar-thumb
      background-color: rgba(255, 255, 255, 0.26)
</style>



// WEBPACK FOOTER //
// src/layouts/ScrollLayout.vue